/**
 * CSS selector matching elements that are reachable via Tab navigation.
 *
 * Note that this is the static markup view: visibility / `display` are filtered
 * at runtime by {@link getTabbableElements} since they cannot be expressed in a
 * selector.
 */
export const TABBABLE_SELECTOR = 'a[href], button:not([disabled]), textarea:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), [tabindex]:not([tabindex="-1"])';
/**
 * Returns the focusable descendants of `root` in DOM order, suitable for
 * implementing a focus trap inside a modal dialog.
 *
 * Elements that are visually hidden via `display: none` or
 * `visibility: hidden` are excluded so that focus is not moved to something the
 * user cannot see.
 */
export function getTabbableElements(root) {
    return [...root.querySelectorAll(TABBABLE_SELECTOR)].filter((el) => {
        const style = window.getComputedStyle(el);
        if (style.display === 'none' || style.visibility === 'hidden') {
            return false;
        }
        return !el.hasAttribute('disabled');
    });
}
